module.exports = __webpack_public_path__ + "images/iStock-113690534311.png";